/**
 * @file AskSpark.ts
 * @brief Ask's icon everywhere: the VERBLIZR logo in its circle.
 *
 * @details
 * DES 09-10-2026: "ask wala icon har jaga replace karo". Mirrors the mobile
 * app's `AskSpark` (FRONTEND `AskLogo`, from "APPS BRANDING/SVG/askicon.svg":
 * two people talking, one asking). Replaces lucide `Sparkles` on every Ask
 * call site (Home intro pill, Meetings library, Ask palette) in one place.
 *
 * Built with lucide-react's `createLucideIcon`, so it takes the same props
 * (className, size, color) as every lucide icon; the source paths are on a
 * 159.63 grid, scaled into lucide's 24 by `transform`. A filled mark:
 * `currentColor` fill, no stroke, so `strokeWidth` has no effect.
 *
 * @author DES
 * @date 09-10-2026
 */

import { createLucideIcon } from "lucide-react";

const FILLED = { fill: "currentColor", stroke: "none", transform: "scale(0.150348)" };

export const AskSpark = createLucideIcon("AskSpark", [
  [
    "path",
    {
      ...FILLED,
      d: "M37.12,95.29l-.15-20.95c-.02-2.43,2.55-3.97,4.53-2.77l18.29,10.34c2.13,1.2,2.16,4.39.04,5.62l-18.14,10.61c-1.97,1.08-4.56-.42-4.58-2.85Z",
      key: "play",
    },
  ],
  [
    "path",
    {
      ...FILLED,
      d: "M79.82,0C35.81,0,0,35.8,0,79.81s35.81,79.82,79.82,79.82,79.81-35.81,79.81-79.82S123.83,0,79.82,0ZM120.13,91.79l18.89-51.67c.31-.87.52-1.76.61-2.65,8.49,11.97,13.49,26.58,13.49,42.34,0,7.11-1.02,13.99-2.92,20.5-.33-.07-.69-.08-1.06-.02l-18.87,3.23c-7.01,1.24-12.68-5.46-10.14-11.73ZM6.52,79.81c0-1.62.05-3.23.16-4.82,2.82-5.83,6.6-11.31,11.33-16.23,24.21-25.21,64.36-26.02,89.57-1.75,1.01.94,1.96,1.92,2.87,2.91,2.63,2.89,3.44,7,2.1,10.65l-15.36,42.01c-2.1,5.2,2.58,10.69,8.37,9.7l15.31-2.65c1.88-.32,3.45,1.47,2.85,3.28-2.86,8.62-7.67,16.72-14.37,23.72-.15.16-.3.31-.47.47-8.91,3.88-18.74,6.02-29.06,6.02-40.42,0-73.3-32.89-73.3-73.31Z",
      key: "mark",
    },
  ],
]);

export default AskSpark;
